export default __webpack_public_path__ + "static/media/2022_05_23 - Puma - 0407.1cb1ec9c.jpeg";